// extracted by mini-css-extract-plugin
export var chevron = "_ms-1";
export var clickable = "_ms-0";
export var ruleRow = "_ms-2";